export class Tabs {
  constructor (elem) {
    this.elem = elem
    this.button = this.elem.querySelectorAll('[data-tabs-btn]')
    this.content = this.elem.querySelectorAll('[data-tabs-content]')
    this.activateTab = this.activateTab.bind(this)
    this.changeTabEvent = this.elem.dataset.changeTab !== undefined ? this.elem.dataset.changeTab : ''

    this.button.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.activateTab(e.currentTarget)
      })

      btn.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          // Enter key
          e.preventDefault()
          e.stopPropagation()
          this.activateTab(e.currentTarget)
        }
      })
    })
  }

  raiseActiveTabEvent (btnValue) {
    if (this.changeTabEvent) {
      const event = new CustomEvent(this.changeTabEvent, {
        bubbles: true,
        detail: {
          buttonID: btnValue
        }
      })
      this.elem.dispatchEvent(event)
    }
  }

  activateTab (clickedBtn) {
    const btnValue = clickedBtn.getAttribute('data-tabs-btn')
    this.button.forEach((btn) => {
      if (btn.getAttribute('data-tabs-btn') === btnValue) {
        btn.setAttribute('data-active', 'true')
        this.raiseActiveTabEvent(btnValue)
      } else {
        btn.removeAttribute('data-active')
      }
    })

    // Deactivate all tabs and activate the matching one
    this.content.forEach((content) => {
      if (content.getAttribute('data-tabs-content') === btnValue) {
        content.setAttribute('data-active', 'true')
      } else {
        content.removeAttribute('data-active')
      }
    })
  }
}

// Set the active tab from outside the class.
export function selectActiveTab (tabId) {
  // Find the button and content to activate.
  const activeButton = document.querySelector(`[data-tabs-btn='${tabId}']`)
  if (activeButton) {
    const activeParent = activeButton.closest('[data-tabs]')
    if (activeParent) {
      const allButtons = activeParent.querySelectorAll('[data-tabs-btn]')
      const allContent = activeParent.querySelectorAll('[data-tabs-content]')

      allButtons.forEach((btn) => {
        if (btn.getAttribute('data-tabs-btn') === tabId) {
          btn.setAttribute('data-active', 'true')
        } else {
          btn.removeAttribute('data-active')
        }
      })

      allContent.forEach((content) => {
        if (content.getAttribute('data-tabs-content') === tabId) {
          content.setAttribute('data-active', 'true')
        } else {
          content.removeAttribute('data-active')
        }
      })
    }
  }
}

export function setupTabs () {
  const elems = document.querySelectorAll('[data-tabs]')
  const tabs = []

  for (const element of elems) {
    tabs.push(new Tabs(element))
  }

  window.selectActiveTab = selectActiveTab

  return tabs
}
